module.exports = __webpack_public_path__ + "static/media/exam.b717e5e8.png";